import { render, staticRenderFns } from "./investDrawer.vue?vue&type=template&id=ec683cb4&scoped=true&"
import script from "./investDrawer.vue?vue&type=script&lang=js&"
export * from "./investDrawer.vue?vue&type=script&lang=js&"
import style0 from "./investDrawer.vue?vue&type=style&index=0&id=ec683cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec683cb4",
  null
  
)

export default component.exports